<template>
  <el-container id="page" style="height: 100%" @scroll="handleScroll">
    <el-header v-if="!isNotFound" id="contentHeader" class="header-back" :style="{ backgroundColor: loading ? '#f5f5f5' : 'transparent' }">
      <!-- :style="{ backgroundImage: 'url(' + bannerImg + ')' }" -->
      <el-menu id="menu-back" class="menu-back" mode="horizontal" :ellipsis="false" :text-color="hAgreement?.color" :default-active="activeIndex">
        <!-- <el-menu-item index="0">
          <router-link :to="{ path: '/' }">LOGO</router-link>
        </el-menu-item> -->
        <div class="logoBox">
          <router-link :to="{ name: 'about', params: { link: currentPath || activeIndex } }">
            <img :src="headLogo" alt="" class="logoStyle" />
          </router-link>
          <div class="titleBox" :class="changeHeader ? 'color_black' : 'color_white'">
            <!-- headData?.headerStyle?.title -->
            <h2 :style="hTitle">{{ headData?.title }}</h2>
            <!-- <span>{{ headData?.titleEn }}</span> -->
          </div>
          <!-- <img :src="require(headLogo)" alt="" /> -->
        </div>
        <div class="flex-grow" />
        <!-- 右侧菜单栏导航数据 -->
        <template v-for="menuItem in menuData" :key="menuItem.id">
          <!-- menuItem.id === cpath ||  -->
          <el-sub-menu v-if="menuItem.id === 'document'" :index="menuItem.id">
            <template #title>{{ menuItem.title }}</template>
            <el-menu-item v-for="item in menuItem.data" :key="item.routerParams" @click="changeRouter(item.routerParams, menuItem.id)" :index="item.id">
              {{ item.routerName }}
            </el-menu-item>
          </el-sub-menu>
        </template>
        <!-- <el-menu-item index="document"> -->
        <!-- <router-link :to="{ name: 'document', params: { type: activeIndex } }">关于</router-link> -->
        <!-- 关于 -->
        <!-- </el-menu-item> -->
      </el-menu>
      <div class="headerContent" v-if="!changeHeader">
        <h1 class="content_title" :style="hContentTitle">{{ headData?.contentTitle }}</h1>
        <div class="content_des" :style="hContentDes">{{ headData?.contentDes }}</div>
      </div>
    </el-header>
    <!-- <el-main v-loading="loading" style="min-height: calc(100vh - 378px); padding: 0"> -->
    <el-main v-loading="loading" style="min-height: calc(100vh - 100px); padding: 0" :style="{ marginTop: loading || isDocument || isNotFound ? '' : '-100px' }">
      <img v-if="!hideBanner" :src="bannerImg" class="banner-img" @load="loaded" style="width: 100%; height: 738px" :style="{ opacity: loading ? 0 : 1 }" />
      <router-view></router-view>
    </el-main>
    <el-footer>
      <Footer />
    </el-footer>
  </el-container>
</template>
<script>
import Footer from '@/components/layout/FooterLayout.vue'
import { ref, toRefs, onMounted, watch, onUnmounted, nextTick, reactive, onUpdated, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { routerData } from './resource/router.js'
export default {
  setup() {
    const setBackColor = ref(false)
    const routerTest = useRouter()
    const activeIndex = ref('offical')
    // url地址路由信息
    const router = ref(useRouter())
    // 菜单信息
    const menuData = ref({ ...routerData })
    // 头部信息 -- 图标、背景图 title 和 英文名
    const headData = ref({
      title: '应用协议',
      titleEn: 'document'
    })
    const hTitle = ref({})
    const hAgreement = ref({})
    const hContentTitle = ref({})
    const hContentDes = ref({})

    const headLogo = ref(require('@/assets/offical/top_logo.png'))
    // 背景图
    const bannerImg = ref()
    // 判断是否改变过header高度
    const changeHeader = ref(false)
    const isNotFound = ref(false)
    const currentPath = ref('')
    const cpath = ref('officalMenu')
    const loading = ref(true)
    const hideBanner = ref(false)
    const isDocument = ref(false)
    watch(
      router.value,
      (newValue, oldValue) => {
        // 判断页面是否是协议
        const pageName = newValue.currentRoute.name
        if (pageName === 'document') {
          hideBanner.value = true
          loading.value = false
          isDocument.value = true
          activeIndex.value = newValue.currentRoute.params.file
          currentPath.value = newValue.currentRoute.params.type
          // menu高度设置
          let dom = document.getElementById('menu-back')
          dom.style.backgroundColor = '#f5f5f5'
          let headerDom = document.getElementById('contentHeader')
          headerDom.style.height = '100px'
          headerDom.style.backgroundColor = '#f5f5f5'
          bannerImg.value = ''
          changeHeader.value = true
          isNotFound.value = false
          getDataObj(currentPath.value)
        }
        if (pageName === '404' || pageName === 'not-found') {
          isNotFound.value = true
          hideBanner.value = true
          loading.value = false
          isDocument.value = false
          // 跳转到404
          routerTest.replace({
            path: '/404'
          })
        }
        const query = newValue.currentRoute.params.link
        if (query && pageName !== 'document' && pageName !== 'document') {
          hideBanner.value = false
          loading.value = true
          isDocument.value = false
          activeIndex.value = query
          currentPath.value = query
          isNotFound.value = false
          if (changeHeader.value) {
            changeHeader.value = false
            // 当协议页面改变过样式需要修复
            // let headerDom = document.getElementById('contentHeader')
            // headerDom.style.height = '768px'
            let dom = document.getElementById('menu-back')
            dom.style.backgroundColor = 'transparent'
          }
          let arr = JSON.parse(JSON.stringify(menuData.value))
          for (let v in arr) {
            arr[v].data.map((d) => {
              if (d.routerParams === newValue.currentRoute.params.link) {
                cpath.value = arr[v].id
              }
            })
          }
          getDataObj(query)
        }

        // 当数据改版后 重新请求顶部数据--logo、应用名、banner图片
      },
      { immediate: true }
    )
    const changeRouter = (type, name) => {
      let pathKey = {
        name: 'about',
        params: {
          link: type
        }
      }
      if (name && name === 'document') {
        pathKey = {
          name: 'document',
          params: {
            type: currentPath.value,
            file: type
          }
        }
      }
      routerTest.push(pathKey)
    }
    const handleScroll = () => {
      // const headerHeight = document.getElementById('contentHeader').clientHeight
      const scrollHeight = document.getElementById('page').getBoundingClientRect().top
      const temp = scrollHeight
      // 当滚动距离大于 660 （banner图即将被抹去时）设置menu背景颜色
      if (!changeHeader.value) {
        if (!setBackColor.value && temp < -2) {
          let dom = document.getElementById('menu-back')
          dom.style.backgroundColor = '#c7dafd'
          setBackColor.value = true
        }
        // 当小于660后 去掉menu背景色
        if (setBackColor.value && temp > -1) {
          let dom = document.getElementById('menu-back')
          dom.style.backgroundColor = 'transparent'
          setBackColor.value = false
        }
      }
    }
    const getDataObj = (query) => {
      let arr = JSON.parse(JSON.stringify(menuData.value))
      for (let v in arr) {
        arr[v].data.map((d) => {
          if (d.routerParams === query) {
            cpath.value = arr[v].id
          }
        })
      }
      import(`@/resource/${query}.js`)
        .then((res) => {
          headData.value = res.data.headData
          const { rechargeAgreement } = headData.value || false
          if (rechargeAgreement) {
            const target = menuData.value.agreementRouter.data.find(item => item.id === "recharge-agreement")
            if (!target) {
              menuData.value.agreementRouter.data.push({
                id: "recharge-agreement",
                routerName: "充值协议",
                routerParams: "recharge-agreement"
              })
            }
          }
          const { title, agreement, contentTitle, contentDes } = headData.value.headerStyle || {}
          // hTitle.value = headData.value.headerStyle.title || {}
          // hAgreement.value = headData.value.headerStyle.agreement || {}
          // hContentTitle.value = headData.value.headerStyle.contentTitle || {}
          // hContentDes.value = headData.value.headerStyle.contentDes || {}
          hTitle.value = title
          hAgreement.value = agreement
          hContentTitle.value = contentTitle
          hContentDes.value = contentDes

          if (res.data.headData.logo) {
            headLogo.value = require(`@/assets/${query}/${res.data.headData.logo}`)
          }
          if (res.data.headData.bannerImg) {
            bannerImg.value = require(`@/assets/${query}/${res.data.headData.bannerImg}`)
            // headLogo.value = require(`@/assets/${query}/${res.data.headData.logo}`)
            // document.getElementById('contentHeader').style.backgroundImage.url = require(`@/assets/offical/back.jepg}`)
            // let dom = document.getElementById('contentHeader')
            // dom.style.backgroundImage = 'url(' + './assets/offical/back.png' + ')'
          }
          nextTick(() => {
            // document.getElementById('app').screenY = 0
            // 滚动到顶部
            const dom = document.getElementById('page')
            dom.scrollIntoView()
          })
        })
        .catch((res) => {
          // 跳转到404
          routerTest.replace({
            path: '/404'
          })
        })
    }
    const loaded = () => {
      loading.value = false
    }
    //页面加载
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })
    //页面卸载
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })
    return {
      changeHeader,
      router,
      menuData,
      headData,
      headLogo,
      hTitle,
      hAgreement,
      hContentTitle,
      hContentDes,
      setBackColor,
      bannerImg,
      changeRouter,
      handleScroll,
      isNotFound,
      activeIndex,
      currentPath,
      cpath,
      loading,
      loaded,
      hideBanner,
      isDocument
    }
  },
  components: {
    Footer
  }
}
</script>
<style lang="scss" scoped>
.header-back {
  padding: 0;
  // z-index: 9999;
  // height: 768px;
  height: 100px;
  // background-color: aqua;
  // background-image: url(@/assets/offical/back.png);
  // background-image: v-bind(bannerImg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  .logoBox {
    padding-left: 20px;
    display: flex;
    align-items: center;
    color: aliceblue;
    .color_black {
      color: #333333;
    }
    .color_white {
      color: #ffffff;
    }
    .logoStyle {
      width: 60px;
      height: 60px;
      border-radius: 5px;
    }
    .titleBox {
      padding-left: 24px;
      display: flex;
      flex-direction: column;
      align-items: start;
    }
  }
  .headerContent {
    position: absolute;
    top: 300px;
    width: calc(100%);
    color: #ffffff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    .content_title {
      font-family: PingFangSC-Regular;
      font-size: 72px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
    .content_des {
      padding-top: 10px;
      width: 60%;
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
  .menu-back {
    z-index: 999;
    background-color: transparent;
    border: none;
    width: calc(100%);
    position: fixed;
    padding: 20px 30px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: right;
    font-weight: 400;
  }
}
.flex-grow {
  flex-grow: 1;
}
</style>
